import {nsRoute} from "../../util/route";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {
}
